import React from 'react';
const Tag = ({ children }) => <div className="ws-ui-base-select-tag">{children}</div>;

export default Tag;
